module.exports = __webpack_public_path__ + "static/media/banner_andarBahar-half.2897c6da.png";